import React from 'react';
import PropTypes from 'prop-types';

function ArrowLeft({
  iconClass,
  width,
  height,
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 448 512"
      className={iconClass || null}
      width={width || null}
      height={height || null}
    >
      <path fill="currentColor" d="M4.7 244.7c-6.2 6.2-6.2 16.4 0 22.6l176 176c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6L54.6 272 432 272c8.8 0 16-7.2 16-16s-7.2-16-16-16L54.6 240 203.3 91.3c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-176 176z" />
    </svg>
  );
}

ArrowLeft.propTypes = {
  iconClass: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
};

export { ArrowLeft };
